/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_B$ as B$,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_t1_116_49(e) {
  let t = (0, ReactCompiler.c)(3),
    { valor: n } = e,
    r = `rounded-full border px-2 py-0.5 text-[11px] ${n === `RESUELTA` ? `border-(--success) text-(--success)` : `border-(--border) text-(--text)`}`,
    i = B$[n] ?? n,
    a;
  return (
    t[0] !== r || t[1] !== i
      ? ((a = <span className={r} children={i} />),
        (t[0] = r),
        (t[1] = i),
        (t[2] = a))
      : (a = t[2]),
    a
  );
}
